export const AI_AUTH_COLORS = {
  primary: '#4754D6',
  primaryMain: '#5B5FC7',
  primaryHover: '#4A4FC0',
  primaryDisabled: '#A2A4DB',
  primaryBorder: '#6066E9',
} as const;
